module.exports = __webpack_public_path__ + "img/arrow.89b81ade.png";